import { getFeature } from 'Cloud/Application/FeaturesEs6';

interface UniqueIdsConfig {
    personal?: boolean;
    public?: boolean;
}

/**
 * @see {@link https://jira.vk.team/browse/CLOUDWEB-18938|CLOUDWEB-18938 Сделать переходы на /doc/word/<doc_id> для редактируемых документов в хомяке}
 */
const DOCUMENTS_UNIQUE_IDS_CONFIG = getFeature('document-unique-ids') as UniqueIdsConfig;

export const DOCUMENTS_UNIQUE_IDS = DOCUMENTS_UNIQUE_IDS_CONFIG?.personal || false;

export const DOCUMENTS_UNIQUE_IDS_PUBLICS = DOCUMENTS_UNIQUE_IDS_CONFIG?.public || false;
